import React, { useRef, useState } from 'react';
import { Tooltip, Box } from '@chakra-ui/react';

/** セル内容省略 + スマートTooltip（テキストが溢れた場合のみTooltip表示） */
const TruncatedCell: React.FC<{ label: string; children: React.ReactNode }> = React.memo(({ label, children }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);
  return (
    <Tooltip label={label} placement="top" hasArrow isOpen={showTooltip}>
      <Box
        ref={ref}
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis"
        onMouseEnter={() => {
          if (ref.current && ref.current.scrollWidth > ref.current.clientWidth) {
            setShowTooltip(true);
          }
        }}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {children}
      </Box>
    </Tooltip>
  );
});

TruncatedCell.displayName = 'TruncatedCell';

export default TruncatedCell;
